"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTableHeaderCellTitle = void 0;
var react_1 = __importDefault(require("react"));
var interfaces_1 = require("./interfaces");
var AcTableHeaderCellTitle = function (_a) {
    var sortable = _a.sortable, sorted = _a.sorted, sortDirection = _a.sortDirection, title = _a.title, name = _a.name, columnIndex = _a.columnIndex, onSort = _a.onSort;
    var onClick = function (e) {
        e.preventDefault();
        var columnId = name || columnIndex;
        if (!columnId)
            throw new Error('Unable to sort');
        var nextSortDirection = sortDirection === interfaces_1.SORT_ASC ? interfaces_1.SORT_DESC : interfaces_1.SORT_ASC;
        if (onSort) {
            onSort(columnId, nextSortDirection);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !sortable && react_1.default.createElement(react_1.default.Fragment, null, title),
        sortable && (react_1.default.createElement("a", { href: "#", onClick: onClick, className: "text-primary" },
            title,
            !sorted && react_1.default.createElement("i", { className: "fad fa-sort fa-fw" }),
            sorted && sortDirection === interfaces_1.SORT_DESC && react_1.default.createElement("i", { className: "fad fa-sort-down fa-fw" }),
            sorted && sortDirection === interfaces_1.SORT_ASC && react_1.default.createElement("i", { className: "fad fa-sort-up fa-fw" })))));
};
exports.AcTableHeaderCellTitle = AcTableHeaderCellTitle;
exports.AcTableHeaderCellTitle.displayName = 'AcTableHeaderCellTitle';
//# sourceMappingURL=AcTableHeaderCellTitle.js.map